export default __webpack_public_path__ + "static/media/Room_3.9eeb9dc3.png";